import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import AdminPagePaymentsCopyChargeButton from "./AdminPagePaymentsCopyChargeButton";
import AdminPagePaymentsCopyCustomerButton from "./AdminPagePaymentsCopyCustomerButton";
import AdminPagePaymentsCopyPaymentIntentButton from "./AdminPagePaymentsCopyPaymentIntentButton";
import AdminPagePaymentsRefundButton from "./AdminPagePaymentsRefundButton";

function AdminPagePaymentsRow(props) {
  const item = props.item;
  const key = props.index;

  return (
    <tr key={key}>
      <td>
        <AdminPagePaymentsRefundButton item={item} />
      </td>
      <td>
        {item.event_entries &&
          item.event_entries[0] &&
          item.event_entries[0].users_public && (
            <Link to={`/player?id=${item.event_entries[0].user_id}`}>
              {item.event_entries[0].users_public.name}
            </Link>
          )}
      </td>
      <td>
        {item.event_entries &&
          item.event_entries[0] &&
          item.event_entries[0].event_id && (
            <Link to={`/event?event=${item.event_entries[0].event_id}`}>
              {item.event_entries[0].events.name}
            </Link>
          )}
      </td>
      <td>{new Date(item.created_at).toLocaleString()}</td>
      <td>{(item.amount_total / 100).toFixed(2)}</td>
      <td>
        {item.amount_refunded != null
          ? (item.amount_refunded / 100).toFixed(2)
          : "0.00"}
      </td>
      {/* <td>{item.charge}</td> */}
      {/* show first 11 digits followed by ... and a copy icon to copy entire string */}
      <td>
        {item.charge && (
          <AdminPagePaymentsCopyChargeButton charge={item.charge} />
        )}
      </td>

      {/* <td>{item.customer}</td> */}
      {/* show first 11 digits followed by ... and a copy icon to copy entire string */}
      <td>
        {item.customer && (
          <AdminPagePaymentsCopyCustomerButton customer={item.customer} />
        )}
      </td>

      {/* <td>{item.payment_intent}</td> */}
      <td>
        {item.payment_intent && (
          <AdminPagePaymentsCopyPaymentIntentButton
            customer={item.payment_intent}
          />
        )}
      </td>
      <td>{item.currency}</td>
      <td>{item.payment_status}</td>
    </tr>
  );
}

export default AdminPagePaymentsRow;
